export const RGBA_MID = 255 / 2;
export const RGBA_MAX = 255;
export const RGBA_MIN = 0;

export const H_MAX = 360;
export const H_MIN = 0;

export const S_MAX = 100;
export const S_MIN = 0;
export const S_MID = 50;

export const L_MAX = 100;
export const L_MIN = 0;
export const L_MID = 50;
